const STORE = "gcw_lang";
const path = typeof window !== "undefined" ? window.location.pathname : "/";

export const IS_ES = path === "/es" || path.startsWith("/es/");
export const LANG = IS_ES ? "es" : "en";
export const BASENAME = IS_ES ? "/es" : undefined;

export const stripLang = (p) => (p === "/es" ? "/" : p.startsWith("/es/") ? p.slice(3) : p);
export const isAdminPath = (p) => /^\/admin(\/|$)/.test(p);
export const withLang = (lang, p) => (lang === "es" ? `/es${p === "/" ? "" : p}` : p);

// Runs before React renders. Returns false when the page is about to redirect.
export function bootLanguage() {
  const { pathname, search, hash } = window.location;
  const bare = stripLang(pathname);
  if (IS_ES && isAdminPath(bare)) {
    window.location.replace(bare + search + hash);
    return false;
  }
  if (!IS_ES && !isAdminPath(pathname)) {
    let pref = localStorage.getItem(STORE);
    if (!pref && /^es\b/i.test(navigator.languages?.[0] || navigator.language || "")) {
      pref = "es";
      localStorage.setItem(STORE, pref);
    }
    if (pref === "es") {
      window.location.replace(withLang("es", pathname) + search + hash);
      return false;
    }
  }
  document.documentElement.lang = LANG;
  return true;
}

export function switchLanguage(to) {
  localStorage.setItem(STORE, to);
  const { pathname, search, hash } = window.location;
  window.location.href = withLang(to, stripLang(pathname)) + search + hash;
}
